import { render, staticRenderFns } from "./OperatnDomiciliInfo.vue?vue&type=template&id=59cab985&"
import script from "./OperatnDomiciliInfo.vue?vue&type=script&lang=ts&"
export * from "./OperatnDomiciliInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
